if (!customElements.get('nm-load-more')) {
  customElements.define(
    'nm-load-more',
    class NmLoadMore extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const link = event.target.closest('a.nm-load-more__button');
        if (!link) return;
        event.preventDefault();
        if (this.hasAttribute('aria-busy')) return;
        this.setAttribute('aria-busy', 'true');

        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const grid = document.getElementById('product-grid');
            html.querySelectorAll('#product-grid > li').forEach((item) => grid.appendChild(item));

            const next = html.querySelector('nm-load-more');
            if (next && next.querySelector('a.nm-load-more__button')) {
              this.innerHTML = next.innerHTML;
              this.removeAttribute('aria-busy');
            } else {
              this.remove();
            }

            if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid);
          })
          .catch(() => {
            // Fall back to plain navigation if the fetch fails
            this.removeAttribute('aria-busy');
            window.location.href = link.href;
          });
      }
    }
  );
}
